import myDetails from "../assets/myDetails.json";

import Footer from '../components/Footer';
import Header from '../components/Header';
import BackBtn from '../components/BackBtn';

function Education() {

    const page_title = "Education"

    return (
        <div className='home-main'>
            <div className='sub-sec'>
                <Header title={page_title} />
                <div className='body-grid'>
                    {myDetails?.education?.slice().reverse().map((school) => (
                        <div key={school.type}>
                            <div className="grid-title">
                                <span>{school.name}</span>
                                <span className='loc-btn'>
                                    <a href={school.gmap} target='_blank' rel='noreferrer'>
                                        <img alt='' className='gen-icon' src="https://img.icons8.com/fluency-systems-filled/48/FFFFFF/marker.png" />
                                    </a>
                                </span>
                            </div>
                            <hr></hr>
                            <div className="grid-body-sub-title">
                                <span>{school.city}, {school.state}, {school.country}</span>
                                <span>{school.start_month.slice(0, 3)} '{school.start_year.toString().slice(-2)} - {school.end_month.slice(0, 3)} '{school.end_year.toString().slice(-2)}</span>
                            </div>
                            <div className="multi-cnt-btn">
                                {school.degree ?
                                    <div className='sm-cnt-btn'>
                                        {school.degree_short} in {school.course_short}
                                    </div> : ``
                                }
                                <div className='sm-cnt-btn'>
                                    Score: {school.score > 10 ? `${school.score.toFixed(2)} %` : `${school.score.toFixed(2)} GPA`}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <BackBtn title={page_title} />
            </div>
            <Footer />
        </div>
    );
}

export default Education;